<script>

/* This is a wrapper around the vue-chartjs Bar chart implementation.
 * It allows us to flexibly modify the standard component and use this version
 * in our app.

  When giving charts datasets to render, the way it works is:

  (passed in to this component as 'chart-data=' prop)
  {
    // for a chart of ounces of liquids drank on each day...

    labels: [ 'Day 1', 'Day 2', 'Day 3' ],        // These two key names need to
    datasets: [                                   // be exactly this.
      {
        label: 'Coffee',            // Name of quantity to be graphing.
        backgroundColor: '#f87979', // Color of the bars.
        data: [16, 32, 4],          // Values to graph PER DAY ABOVE.
      },
      {
        label: 'Water',
        backgroundColor: '#f87979',
        data: [10, 44, 120],
      },
    ]
  }

  Important to note is that the number of items in each datasets' 'data' array
  must be equal to the number of 'labels' in the overall object. these items in
  the 'data' array get mapped onto the 'labels'. So in the Coffee dataset,
  Day 1 = 16
  Day 2 = 41
  Day 3 = 4

 */


import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // this.chartData is created internally in the mixin, but is passed into this
    // component as a prop...
    // This is a vue-chartjs oddity
    this.renderChart(this.chartData, this.options)
  }
}
</script>

